// extracted by mini-css-extract-plugin
export default {"textSmall":"RocVY2A37XqiKJkwdoXz","divider":"MP56Po4iBv9GEMU9BaBA"};